import { render, staticRenderFns } from "./studentsWorkModule.vue?vue&type=template&id=64a8ed68&scoped=true"
import script from "./studentsWorkModule.vue?vue&type=script&lang=js"
export * from "./studentsWorkModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a8ed68",
  null
  
)

export default component.exports